<script>
import { plansof } from '@/utils/chain';
import { mapGetters } from 'vuex';
import { couponSourceTypeMap } from '@/views/config/coupon/helper/constant';
import { BILLING_CYCLE } from '@/common/constants';

export default {
  props: {
    type: String,
    code: String, // optional, to make it more accurate
  },
  computed: {
    ...mapGetters(['isProrated', 'isProratedLoading', 'getSelectedPlans', 'boughtPlans', 'couponState', 'getSelectedPlansMap0', 'oldPlanCode']),
    mx_is() {
      return this.isProrated;
    },
    mx_loading() {
      return this.isProratedLoading;
    },
    mx_is_annual_term_monthly() {
      return this.mx_cartPlan.billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY
    },
    // only for a specific type
    mx_cartPlan() {
      if(this.code) return plansof(this.getSelectedPlans).code(this.code).get(0);
      return plansof(this.getSelectedPlans).type(this.type).get(0);
    },
    // only for a specific type
    mx_boughtPlan() {
      if(this.code) return plansof(this.boughtPlans).code(this.code).get(0);
      const category = this.mx_cartPlan.category;
      const boughtPlans = plansof(this.boughtPlans).type(this.type).category(category).plans;
      if (boughtPlans.length > 1) {
        return boughtPlans.find(x => x.plan_code === this.oldPlanCode);
      }
      return boughtPlans[0];
    },
    mx_isMultipleIncremental(){
      const boughtPlansMap = this.boughtPlans.reduce((acc, x) => {
        acc[x.plan_code] = x.cartInfo?.selected_number;
        return acc;
      }, {});
      const selectedPlansMap = this.getSelectedPlans.reduce((acc, x) => {
        acc[x.plan_code] = x.cartInfo?.selected_number;
        return acc;
      }, {});
      // TODO depending on initial cart state is fragile
      const selectedPlanCodes0 = Object.keys(this.getSelectedPlansMap0)
      const noRemoval = this.$context.is.upsell || (selectedPlanCodes0.every(x => {
        return selectedPlansMap[x] > 0
      }));
      const noDecrease = this.getSelectedPlans.every(x => {
        return x.cartInfo?.selected_number >= (boughtPlansMap[x.plan_code]??0);
      });
      const hasIncremental = this.getSelectedPlans.some(x => {
        return x.cartInfo?.selected_number > (boughtPlansMap[x.plan_code]??0);
      });
      return noRemoval && noDecrease && hasIncremental;
    },
    mx_isSingleIncreaseLicense(){
      return this.getSelectedPlans.every(cartPlan => {
        const boughtPlan = this.boughtPlans.find(x => {
          // change of billing cycle & capacity => planCode change
          return [cartPlan?.plan_code, cartPlan?.priceChangeMappingPlanCode].includes(x.plan_code)
        });
        if(!boughtPlan) return false;
        return (cartPlan.cartInfo?.selected_number??0) > (boughtPlan.cartInfo?.selected_number??0);
      });
    },
    mx_prorated4SupportedCouponCase() {
      // support coupon is support prorated feature switch
      if (!this.$isEnabled('disabledSupportCouponProrated')) {
        return this.couponState?.couponSourceType === couponSourceTypeMap.supportCoupon;
      }

      return false;
    },
  },
};
</script>
